/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'file-post-fill': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M12 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V2a2 2 0 00-2-2M4.5 3h5a.5.5 0 010 1h-5a.5.5 0 010-1m0 2h7a.5.5 0 01.5.5v8a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5"/>',
    },
});
